import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Vuex from "vuex";

import activeProcess from "@/store/modules/activeProcess.js";
import user from "@/store/modules/user.js";
import path from "@/store/modules/path.js";
import users from "@/store/modules/users.js";
import calls from "@/store/modules/calls.js";
import search from "@/store/modules/search.js";
import locale from "@/store/modules/locale.js";
import invites from "@/store/modules/invites.js";
import company from "@/store/modules/company.js";
import vacancy from "@/store/modules/vacancy.js";
import vacancy_new from "@/stores_new/vacancy_new/index.js";
import managers from "@/store/modules/managers.js";
import response from "@/store/modules/response.js";
import responses from "@/store/modules/responses.js";
import responses_new from '@/store_refactor/responses/responses.js';
import interview from "@/store/modules/interview.js";
import dictionary from "@/store/modules/dictionary.js";
import global from "@/store/modules/global.js";
import situation from "@/store/modules/situation/index.js";
import analytics from "@/store/modules/analytics/analytics.js";
import siteinformers from "@/store/modules/siteinformers.js";
import { companyModules, adminCompanyModules, globalModules } from "@/stores_new/company_modules/index.js";

// new stores
import appInit from '@/store_refactor/_app-init.js';
import usernew from '@/stores_new/user/index.js'
import tests from '@/stores_new/tests/index.js'
import vacancyTests from '@/store_refactor/vacancy/vacancy-tests.js'
import questions from '@/stores_new/questions/index.js'
import services from '@/stores_new/services/index.js'
import company_new from '@/stores_new/company/index.js'
import vacancies from '@/store_refactor/vacancies.js'
// import candidate_test from '@/stores_new/candidate_test'
// integrations
import integrations from '@/store_refactor/integrations.js';
import integrationsHeadhunter from '@/store_refactor/integrations/integrations-headhunter.js';
import integrationsHeadhunterAutosearch from '@/store_refactor/integrations/integrations-headhunter-autosearch.js';
import integrationsHackerrank from '@/store_refactor/integrations/integrations-hackerrank.js';
import integrationsHrm from '@/store_refactor/integrations/integrations-hrm.js';
import integrationsAssessfirst from '@/store_refactor/integrations/integrations-assessfirst.js';

import vcvTags from "@/store_refactor/vcv-tags.js";
import admin_new from "@/stores_new/admin/index.js";
import express_invites from "@/stores_new/express_invites/index.js";
import online_interview from "@/stores_new/online_interview/index.js";
import record_interview from '@/stores_new/interview_new/index.js';
import landing from "@/stores_new/landing/index.js";
// process store
import processStore from "@/process/store.js";

import sibur_process_define from "@/process/sibur-test/store/processDefine";
import router from '@/routes_new/index.js';
Vue.use(Vuex);

/**
 * Check if module registred (it removes duplicate registrations errors)
 * @param { Array } aPath - path to module - ex: ['my', 'nested', 'module']
 * @return { Boolean }
 */
Vuex.Store.prototype.$hasModule = function (aPath) {
  let m = this._modules.root;

  return aPath.every((p) => {
    m = m._children[p];
    return m;
  });
};

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",

  state: {
    route: null,
    pageStatusCode: null,
    googleMapsLoaded: false
  },

  mutations: {
    updateRoute(state, data) {
      state.route = data;
    },
    updatePageStatus(state, statusCode) {
      state.pageStatusCode = statusCode;
    },
    googleApiLoaded(state) {
      state.googleMapsLoaded = true;
    }
  },

  getters: {
    page_status_code(state, getters) {
      return state.pageStatusCode;
    }
  },

  modules: {
    appInit,
    activeProcess,
    user,
    path,
    users,
    calls,
    search,
    locale,
    invites,
    company,
    vacancy,
    vacancy_new,
    managers,
    response,
    vacancies,
    // refactor 2022 - 2023
    // integrations
    integrations,
    integrationsHeadhunter,
    integrationsHeadhunterAutosearch,
    integrationsHackerrank,
    integrationsHrm,
    integrationsAssessfirst,
    vcvTags,
    vacancyTests,
    responses_new,

    responses,
    interview,
    dictionary,
    global,
    process: processStore,
    situation,
    analytics,
    siteinformers,
    tests,
    questions,
    usernew,
    services,
    company_new,
    globalModules,
    companyModules,
    adminCompanyModules,
    admin_new,
    express_invites,
    online_interview,
    landing,
    record_interview,
    // process
    sibur_process_define
  },

  plugins: [
    store => {
      store.$router = router;
    }
  ]
});

const initialStateCopy = JSON.parse(JSON.stringify(store.state));

export function resetState() {
  const clone = Object.assign(JSON.parse(JSON.stringify(initialStateCopy)), {
    route: store.state.route,
    locale: store.state.locale,
    situation: store.state.situation
  });
  store.replaceState(clone);
}

export default store;
